import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as mainActions from '../../actions/mainActions';
import { Grid, AppBar, Tab, Tabs, Card } from 'material-ui';
import PeopleByCountry from './PeopleByCountry';
import PeopleByComunity from './PeopleByComunity';
import PeopleByProvince from './PeopleByProvince';
import PeopleByMunicipalities from './PeopleByMunicipalities';
import moment from 'moment';
import { toast } from 'react-toastify';
import SelectComponent from '../displayComponents/SelectComponent';
import DatePickerCustom from '../displayComponents/DatePickerCustom';

class SurveyResultsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            selectedTab: 'COUNTRY',
            filter: {
                from: moment()
                    .subtract(3, "month")
                    .format("DD/MM/YYYY 00:00"),
                to: moment().format("DD/MM/YYYY 23:59"),
                selectedComunities: [],
                selectedProvinces: [],
                selectedMunicipalities: [],
                selectedCountries: [],
                office: -1,
                municipality: -1
            },
        }
    }
    componentDidMount(){
        const { sessionData } = this.props.main;
        this.setState({ filter: { ...this.state.filter,  municipality: sessionData.municipality || -1}, loading: false });
    }

    updateFilter = (value, name) => {
        if (!validateDatesFilter(this.state.filter.from, this.state.filter.to, { value: value, name: name })) return toast("A data elexida no é válidas", { className: "toast-error", autoClose: 2000 });
        let filter = {};
        filter[name] = value;
        if(name === 'municipality') filter.office = -1;
        this.setState({ filter: { ...this.state.filter, ...filter } });
    }

    handleChange = (event, value) => {
        this.setState({ selectedTab: value });
    }

    render() {
        const { selectedTab, loading, filter: { from, to, office, municipality, selectedComunities, selectedCountries, selectedMunicipalities, selectedProvinces } } = this.state;
        const { offices, countries, municipalities, comunities, provinces, sessionData } = this.props.main;
        const { appBar, tab, selected } = styles;
        const { filter } = this.state;

        return (
            <Fragment>
                <AppBar position="static" elevation={1} style={{
                    backgroundColor: "#EEE",
                    color: "#333",
                    marginBottom: "1em"
                }}>
                    <Tabs value={selectedTab} onChange={this.handleChange}>
                        {/*<Tab style={selectedTab === 0 ? selected : tab} label="Estatísticas generales" />*/}
                        <Tab style={selectedTab === 'COUNTRY' ? selected : tab} label="Estatísticas por país" value={'COUNTRY'} />
                        <Tab style={selectedTab === 'COMUNITY' ? selected : tab} label="Estatísticas por comunidade" value={'COMUNITY'} />
                        <Tab style={selectedTab === 'PROVINCES' ? selected : tab} label="Estatísticas por provincia" value={'PROVINCES'} />
                        <Tab style={selectedTab === 'MUNICIPALITIES' ? selected : tab} label="Estatísticas por localidade" value={'MUNICIPALITIES'} />
                    </Tabs>
                </AppBar>
                <Card elevation={0} style={{ width: '100%', padding: '0 1em', marginBottom: '1em', marginTop: '-0.5em' }}>
                    <Grid container spacing={16}>
                        <Grid item xs={4}>
                            <div style={{ flexDirection: 'column' }}>
                                <DatePickerCustom
                                    label="Dende"
                                    value={from}
                                    format="DD/MM/YYYY"
                                    displayFormat="LL"
                                    setDate={(moment) => { this.updateFilter(moment.format('DD/MM/YYYY HH:mm'), 'from') }}
                                />
                                <DatePickerCustom
                                    label="Ata"
                                    value={to}
                                    format="DD/MM/YYYY"
                                    displayFormat="LL"
                                    setDate={(moment) => { this.updateFilter(moment.format('DD/MM/YYYY HH:mm'), 'to') }}
                                />
                            </div>

                        </Grid>
                        <Grid item xs={4}>
                            <SelectComponent
                                disabled={!!sessionData.municipality}
                                label="Concello"
                                defaultValue="Todos"
                                items={municipalities}
                                value={municipality}
                                fieldValue="id"
                                fieldName="name"
                                setValue={event => {
                                    this.updateFilter(event.target.value, "municipality");
                                }} />
                            <br />
                            <SelectComponent
                                label="Oficina"
                                defaultValue="Todas"
                                items={(!!municipality && municipality != -1) ? offices.filter((office) => { return office.municipality_id === municipality }) : offices}
                                value={office}
                                fieldValue="id"
                                fieldName="name"
                                setValue={event => {
                                    this.updateFilter(event.target.value, "office");
                                }}
                            />
                            <div>
                                {selectedTab === 'COUNTRY' &&
                                    <SelectComponent
                                        label="País"
                                        items={countries}
                                        fieldName="name_gl"
                                        fieldValue="id"
                                        value={selectedCountries}
                                        setValue={(event) => { this.updateFilter(event.target.value, 'selectedCountries') }}
                                        multiple={true} />
                                }
                                {selectedTab === 'COMUNITY' &&
                                    <SelectComponent
                                        label="Comunidade"
                                        items={comunities}
                                        fieldName="name"
                                        fieldValue="id"
                                        value={selectedComunities}
                                        setValue={(event) => { this.updateFilter(event.target.value, 'selectedComunities') }}
                                        multiple={true} />
                                }
                                {selectedTab === 'PROVINCES' &&
                                    <SelectComponent
                                        label="Provincia"
                                        items={provinces}
                                        fieldName="name"
                                        fieldValue="id"
                                        value={selectedProvinces}
                                        setValue={(event) => { this.updateFilter(event.target.value, 'selectedProvinces') }}
                                        multiple={true} />
                                }
                                {selectedTab === 'MUNICIPALITIES' &&
                                    <SelectComponent
                                        label="Localidades"
                                        items={municipalities}
                                        fieldName="name"
                                        fieldValue="id"
                                        value={selectedMunicipalities}
                                        setValue={(event) => { this.updateFilter(event.target.value, 'selectedMunicipalities') }}
                                        multiple={true} />
                                }
                            </div>
                        </Grid>
                        <Grid item xs={4}></Grid>
                    </Grid>
                </Card>
                {!loading &&
                    <Grid container justify="center">
                        {/*selectedTab === 0 && (<GeneralView />)*/}
                        {selectedTab === 'COUNTRY' &&
                            <PeopleByCountry filter={filter} />
                        }
                        {selectedTab === 'COMUNITY' &&
                            <PeopleByComunity filter={filter} />
                        }
                        {selectedTab === 'PROVINCES' &&
                            <PeopleByProvince filter={filter} />
                        }
                        {selectedTab === 'MUNICIPALITIES' &&
                            <PeopleByMunicipalities filter={filter} />
                        }
                </Grid>
                }                    
            </Fragment>
        );
    }
}

const styles = {
    tab: {
        minWidth: "25%",
        backgroundColor: 'white'
    },
    selected: {
        minWidth: "25%",
        backgroundColor: "#bcd5fd"
    }
}

export const validateDatesFilter = (from, to, date) => {
    let result = true;
    if (date.name === 'from') {
        if (moment(date.value, 'DD/MM/YYYY HH:mm').isAfter(moment(to, 'DD/MM/YYYY HH:mm'))) result = false;
    }
    if (date.name === 'to') {
        if (moment(date.value, 'DD/MM/YYYY HH:mm').isBefore(moment(from, 'DD/MM/YYYY HH:mm'))) result = false;
    }
    return result;
}

const mapStateToProps = (state) => ({
    main: state.main
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(mainActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SurveyResultsContainer);



// WEBPACK FOOTER //
// ./src/components/SurveyResults/SurveyResultsContainer.js